// @flow

import type {
  UserOperationsById,
} from 'fc-operator-user/types'

// Constants
import {
  TREE,
  OPERATIONS_BRANCH,
} from '../constants'

import traverse from 'fc-utils/traverse'

type UserOperationsSelector = (state: Object) => UserOperationsById

export default (traverse([TREE, OPERATIONS_BRANCH]): UserOperationsSelector)
